import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import { MOOD_COLORS } from "../../../constants/moodColors";
import EmptyState from "../../../components/EmptyState";
import type { BalancePieDataItem } from "../../../features/trends/hooks/useTrendsData";
import styles from "./MoodBalanceChart.module.css";

type MoodBalanceChartProps = {
  balancePieData: BalancePieDataItem[];
  totalMoods: number;
};

const MoodBalanceChart = ({
  balancePieData,
  totalMoods,
}: MoodBalanceChartProps) => {
  const legendEntries = balancePieData.filter(
    (entry) => entry.name !== "AnxietyApathy" && entry.name !== "FlowConfident"
  );

  return (
    <>
      <div className={styles["pie-container"]}>
        {totalMoods > 0 ? (
          <>
            <div className={totalMoods > 0 ? styles.pieSpinning : undefined}>
              <PieChart
                width={300}
                height={180}
                onClick={() => {}} // Disable clicking
                onMouseEnter={() => {}} // Disable hover
                onMouseLeave={() => {}} // Disable hover
              >
                <Pie
                  data={balancePieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={75}
                  dataKey="value"
                  startAngle={90}
                  endAngle={-270}
                  paddingAngle={2}
                >
                  {balancePieData.map((entry, index) => {
                    const color =
                      entry.color ||
                      MOOD_COLORS[entry.name as keyof typeof MOOD_COLORS] ||
                      "#D3D3D3";
                    return <Cell key={`cell-${index}`} fill={color} />;
                  })}
                </Pie>
              </PieChart>
            </div>

            <div className={styles["legend-container"]}>
              {legendEntries.map((entry, index) => {
                const color =
                  entry.color ||
                  MOOD_COLORS[entry.name as keyof typeof MOOD_COLORS] ||
                  "#D3D3D3";
                return (
                  <div key={index} className={styles["legend-item"]}>
                    <div
                      className={styles["legend-color"]}
                      style={{ backgroundColor: color }}
                    />
                    <span className="legend-text">
                      <span className="legend-label">{entry.name}</span>{" "}
                      <span className="legend-percentage">
                        {entry.percentage || ""}
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <EmptyState title="No mood data available" />
        )}
      </div>
    </>
  );
};

export default MoodBalanceChart;
